import React, { Component } from 'react'
import LinkSet, { LinkModel } from '../link-set/LinkSet'
import './footer-links-group.scss'

export interface FooterLinksGroupModel {
  title: string
  links?: LinkModel[]
  contacts?: {
    mail?: string
    tel?: { value: string; displayValue: string }
    fax?: string
    workingDays?: string
  }[]
}

class FooterLinksGroup extends Component {
  props: FooterLinksGroupModel

  render() {
    return (
      <div className={'la-footer-links-group'}>
        <strong className={'la-footer-links-group__title'}>{this.props.title}</strong>
        {this.props.links && (
          <div className={'la-footer-links-group__links'}>
            <LinkSet links={this.props.links} />
          </div>
        )}
        {this.props.contacts && (
          <div className={'la-footer-links-group__contacts-group-set la-footer-contacts-group-set'}>
            {this.props.contacts.map((contacts, i) => (
              <ul className={'la-footer-contacts-group-set__item la-footer-contact-set'} key={i}>
                {contacts.mail && (
                  <li className={'la-footer-contact-set__item'}>
                    <a className={'la-link'} href={`mailto:${contacts.mail}`} key={i}>
                      {contacts.mail}
                    </a>
                  </li>
                )}
                {contacts.tel && (
                  <li className={'la-footer-contact-set__item'}>
                    <a className={'la-link'} href={`tel:${contacts.tel?.value}`} key={i}>
                      {contacts.tel?.displayValue}
                    </a>
                  </li>
                )}
                {contacts.workingDays && (
                  <li
                    className={
                      'la-footer-contact-set__item la-footer-contact-set__item_working-days'
                    }
                  >
                    {contacts.workingDays}
                  </li>
                )}
                {contacts.fax && (
                  <li className={'la-footer-contact-set__item la-footer-contact-set__item-fax'}>
                    eFAX:&nbsp;{contacts.fax}
                  </li>
                )}
              </ul>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default FooterLinksGroup
